export default class Configuration {
  static SERVER_BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;
  static INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID;
  static SUBMIT_INVOICE_URL = process.env.REACT_APP_SUBMIT_INVOICE_URL;
  static ADMIN_CONSOLE_SESSIONS_LINK = process.env.REACT_APP_ADMIN_CONSOLE_SESSIONS_LINK;
  static EMAILS = {
    disabled: process.env.REACT_APP_DISABLE_EMAILS === "true",
    url: process.env.REACT_APP_SEND_EMAIL_URL,
    receiver: process.env.REACT_APP_EMAIL_RECEIVER,
    newTagRequestReceiver: process.env.REACT_APP_NEW_TAG_EMAIL_REQUEST_RECEIVER,
  };
  static ENABLE_LOGGING = process.env.REACT_APP_ENABLE_LOGGING;
  static SLACK = {
    enable: process.env.REACT_APP_ENABLE_SLACK_NOTIFICATIONS,
    webHookUrl: process.env.REACT_APP_SLACK_WEB_HOOK_URL,
    channel: process.env.REACT_APP_SLACK_CHANNEL,
  };
  static COOKIE_NOTIFICATION_DISABLED =
    process.env.REACT_APP_DISABLE_COOKIE_NOTIFICATION === "true";
  static GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
  static BLOOMBERG_LIBRARY_OBJECT_ID = process.env.REACT_APP_BLOOMBERG_LIBRARY_OBJECT_ID;
  static ACTION_CLICK_TIMEOUT = parseInt(process.env.REACT_APP_ACTION_CLICK_TIMEOUT, 10);
  static USERS_TO_EDIT_LIBRARY_CONTENT = JSON.parse(process.env.REACT_APP_CONTENT_ADMINS);
  static STRIPE_KEY = process.env.REACT_APP_STRIPE_API_KEY || "";
  static SHOW_INTERCOM = process.env.REACT_APP_SHOW_INTERCOM === "true";
  static PROMO_ENABLED = process.env.REACT_PROMO_ENABLED === "true";
  static GOOGLE_ANALYTICS_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
  static USE_MOUSEFLOW = process.env.REACT_APP_USE_MOUSEFLOW === "true";
  static ENABLE_CONSOLE_LOGGING = process.env.REACT_APP_ENABLE_CONSOLE_LOGGING === "true";
  static ENABLE_V2_HR_DASHBOARD = process.env.REACT_APP_ENABLE_V2_HR_DASHBOARD === "true";
  static MICROSOFT_CLARITY = {
    script: process.env.REACT_APP_CLARITY_SCRIPT || "",
  };
}
